import * as React from 'react'

import useStyles from './style.js'
import Typography from '@material-ui/core/Typography';

function Copyright() {
    const classes = useStyles();
    return (
        <Typography variant="body2" color="textSecondary" className={classes.copyright}>
            {'Copyright © '}
            {'A Home For Work'}
            {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

async function client(endpoint,{data, token, headers: customHeaders, ...customConfig} = {}) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
       credentials: 'include',
    headers: {
      // TODO put back in for authentication 
      //Authorization: token ? `Bearer ${token}` : undefined,
      'Content-Type': data ? 'application/json' : undefined,
      'Accept': 'application/json',
      ...customHeaders,
    },
    ...customConfig,
  }

    return window.fetch(`${endpoint}`, config).then(async response => {
        try {
            const data = await response.json()

            if (response.ok) {
                console.log('response', data)
                return data
            } else {
                return Promise.reject(Object.assign({code: response.status}, data))
            }
        } catch(e) {
            return Promise.reject(Object.assign({code: response.status}, data))
        }
    })
}

function useClient() {
    let token = null
    return React.useCallback(
        (endpoint, config) => client(endpoint, {...config, token}),
        [token],
    )
}

export {useClient, client, Copyright}
